export default "__VITE_ASSET__Zh$K5pZ2__"